<template>
  <div class='booking-details__guests-modal'>
    <h3 class='modal__title'>Guests</h3>
    <div class='booking-details__guests-modal-subheading'>This place accept maximum 5 guests. Pets not allowed</div>
    <div class='flex items-center justify-between py-3 border-b border-[#E1E4EB]'>
      <span class='booking-details__guests-modal-value-title'>Adults</span>
      <div class='flex items-center gap-4'>
        <span class='booking-details__guests-modal-number-btn' @click="subtractValue('adults')"><i class='icon-minus'></i></span>
        <input class='booking-details__guests-modal-input' v-model='adults' type='number' readonly>
        <span class='booking-details__guests-modal-number-btn' @click="addValue('adults')"><i class='icon-plus'></i></span>
      </div>
    </div>
    <div class='flex items-center justify-between py-3 border-b border-[#E1E4EB]'>
      <span class='booking-details__guests-modal-value-title'>Kids</span>
      <div class='flex items-center gap-4'>
        <span class='booking-details__guests-modal-number-btn' @click="subtractValue('kids')"><i class='icon-minus'></i></span>
        <input class='booking-details__guests-modal-input' v-model='kids' type='number' readonly>
        <span class='booking-details__guests-modal-number-btn' @click="addValue('kids')"><i class='icon-plus'></i></span>
      </div>
    </div>
    <div class='flex items-center justify-between py-3 relative'>
      <span class='booking-details__guests-modal-value-title'>Pets</span>
      <div class='flex items-center gap-4'>
        <span class='booking-details__guests-modal-number-btn' @click="subtractValue('pets')"><i class='icon-minus'></i></span>
        <input class='booking-details__guests-modal-input' v-model='pets' type='number' readonly>
        <span class='booking-details__guests-modal-number-btn' @click="addValue('pets')"><i class='icon-plus'></i></span>
      </div>
      <div v-if='disable_pets' class='booking-details__guests-modal-disabled'/>
    </div>
    <div class='flex justify-between mt-3'>
      <span class='theme-btn theme-btn--text' @click='resetGuests'>
          <i class='icon-replay' style='font-size: 20px;'></i>
          Reset guests
      </span>
      <span class='theme-btn theme-btn--theme' @click='saveGuests'>Save changes</span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      max_guests: {
        default: 10,
        type: Number,
      },
      disable_pets: {
        default: false,
        type: Boolean
      },
      initialAdults: {
        default: 0,
        type: Number,
      },
      initialKids: {
        default: 0,
        type: Number,
      },
      initialPets: {
        default: 0,
        type: Number,
      },
    },
    data() {
      return {
        adults: 0,
        kids: 0,
        pets: 0,
      };
    },
    methods: {
      resetGuests: function() {
        this.adults = 0;
        this.kids = 0;
        this.pets = 0;
      },
      saveGuests: function() {
        this.$emit('update_guests', {guests: this.adults, kids: this.kids, pets: this.pets});
        this.$emit('close_modal');
      },
      subtractValue: function(dataName) {
        if (this[dataName] === 0) return;
        this[dataName]--;
      },
      addValue: function(dataName) {
        if (dataName === 'adults' && this[dataName] === this.max_guests) return;
        this[dataName]++
      },
    },
    mounted() {
      this.adults = this.initialAdults;
      this.kids = this.initialKids;
      this.pets = this.initialPets;
    }
  };
</script>